export default __webpack_public_path__ + "static/toki-0302354eb6c3530670d7e455f0550d94.jpg";